// 系统公用常量
export const EMPTY_MUTATION = 'EMPTY_MUTATION'

// ajax共通前缀，一般用于验证码这种放不进api/index的奇葩请求
export const GET_AJAX_BASE_URL = 'GET_AJAX_BASE_URL'

// 图片路径
export const GET_IMAGE_SRC_PREFIX = 'GET_IMAGE_SRC_PREFIX'

// 合同图片或者pdf内容
export const GET_CONTRACT_IMAGE_SRC = 'GET_CONTRACT_IMAGE_SRC'
export const GET_CONTRACT_IMAGE_SRC_BL = 'GET_CONTRACT_IMAGE_SRC_BL'

// 用户相关
export const GET_USER = 'GET_USER'
export const SET_USER = 'SET_USER'
export const POST_USER = 'POST_USER'
export const PUT_USER = 'PUT_USER'
export const IS_LOGIN = 'IS_LOGIN'

// 页面是否加载中
export const GET_FULL_SCREEN_LOADING_STATE = 'GET_FULL_SCREEN_LOADING_STATE'
export const SET_FULL_SCREEN_LOADING_STATE = 'SET_FULL_SCREEN_LOADING_STATE'

// 全局设置，便于修改部分公司信息
export const GET_COMPANY_INFO = 'GET_COMPANY_INFO'
export const SET_COMPANY_INFO = 'SET_COMPANY_INFO'

// 获取合作银行列表
export const GET_ABOUT_US_DATA = 'GET_ABOUT_US'
export const GET_ABOUT_US = 'GET_ABOUT_US'
export const SET_ABOUT_US = 'SET_ABOUT_US'

// 是否启用额度开关
export const IS_USEING_LIMIT = 'IS_USEING_LIMIT'
export const GET_ENABLE_CREDIT_QUOTA_SWITCH = 'GET_ENABLE_CREDIT_QUOTA_SWITCH'
export const SET_ENABLE_CREDIT_QUOTA_SWITCH = 'SET_ENABLE_CREDIT_QUOTA_SWITCH'

// 加密公钥
export const GET_GENERATE_RSA_PUBLIC_KEY = 'GET_GENERATE_RSA_PUBLIC_KEY'



// WEBPACK FOOTER //
// ./src/vuex/types/common.js